export default "__VITE_ASSET__Bk5ueAeZ__"